// extracted by mini-css-extract-plugin
export default {"map":"Track_map__q35VQ","orderId":"Track_orderId__GMOyb","text":"Track_text__mV22V"};